import React, {useEffect, useState} from "react";
import Polyfill from "../../polyfill/polyfill";
import { Route, Switch, useHistory } from "react-router-dom";
import { Cookie, Intercom } from "../../components";
import NotFound from "../../components/404-2";
import Offline from "../../components/offline-2";
import EditorLayout from "../builder/theme-layout";
import DashboardLayout from "./layouts/dashboard";
import SettingsLayout from "./layouts/settings";
import SetupLayout from "./layouts/setup";
import DocumentationLayout from "./layouts/docsumentation";
import StoreLayout from "./layouts/store";
import { useDispatch } from "react-redux";
import { getSelfUser } from "../../services/auth/actions";
import { redirectToSubLink } from "../../components/subdomainLink";
import { useCookies } from "react-cookie";
import useAuthCookies from '../../hooks/useAuthCookies';
import useOnlineStatus from "../../hooks/useOnlineStatus";
import i18n from "../main/i18";


import Snow from "./snow";

import "./app.scss";
import {useLocation} from "react-router";



export default function App() {

	const dispatch = useDispatch();
	const history = useHistory();
	const location = useLocation();
	const [cookies] = useCookies(["accessToken"]);
	const { removeCookies } = useAuthCookies();
	const { isOnline } = useOnlineStatus();
	const [ lang, setLang ] = useState(i18n.resolvedLanguage);

	useEffect(() => {

		const html = document.documentElement.classList;
		const body = document.body.classList;
		const elem = document.querySelector("#loader");

		// console.log("%cWelcome to Paylix!", "font-size: 5em; margin: 1em 0; color: SandyBrown; text-shadow: 0.02em 0.02em 0 Brown, 0 0 0.5em violet;");
		// console.log("%cIf someone asked you to paste anything in here:", "font-size: 2rem; margin: .5em 0; color: SandyBrown; text-shadow: 0.02em 0.02em 0 Brown, 0 0 0.5em violet;");
		// console.log("%cDON'T do it!", "font-size: 2rem; margin: .5em 0; color: SandyBrown; text-shadow: 0.02em 0.02em 0 Brown, 0 0 0.5em violet;");
		// console.log("%cYour account, shop, and purchases will more than likely be compromised if you do so.", "font-size: 2rem; margin: .5em 0; color: SandyBrown; text-shadow: 0.02em 0.02em 0 Brown, 0 0 0.5em violet;");


		body.remove("scroll-hidden");
		body.add("notransition");

		setTimeout(() => {
			if(elem) {
				elem.parentNode.removeChild(elem);
			}
			html.remove("scroll-hidden");
			body.remove("notransition");
		}, 1500);


		let redirect = localStorage.getItem("auth-redirect");

		if(redirect) {
			history.push(redirect);
			localStorage.removeItem("auth-redirect");
		}

		if(cookies.accessToken) {
			dispatch(getSelfUser())
				.catch((res) => {
					if(res && (res.status === 401 || res.status === 400)) {
						removeCookies();
						localStorage.setItem("auth-redirect", location.pathname);
						redirectToSubLink('auth', "/login", history);
					}
				});
		} else {
			localStorage.removeItem("searchbar-tip");
			localStorage.setItem("auth-redirect", location.pathname);
			console.log(redirect);
			redirectToSubLink('auth', "/login", history);
		}

	}, []);

	return (
		<>
			<Polyfill />
			<Cookie isDashboard />
			<Intercom />
			{/*<Snow />*/}

			{isOnline ? null : <Offline />}
			<Switch>
				<Route path="/setup" component={SetupLayout} />
				<Route path="/settings" component={SettingsLayout} />
				<Route path="/customization/documentation" component={DocumentationLayout} />
				<Route path="/customization/store" component={StoreLayout} />
				<Route path="/customization/themes/:themeId/conflicts" component={EditorLayout} />
				<Route path="/editor" component={EditorLayout} />
				<Route path="*" component={DashboardLayout} />
				<Route>
					<NotFound isDashboard />
				</Route>
			</Switch>
			<div id="modal"></div>
		</>
	)
}

